// extracted by mini-css-extract-plugin
export default {"menuList":"brand-global-nav-menus-MenuList__menuList--3fbpS","fixedWidth":"brand-global-nav-menus-MenuList__fixedWidth--1BuQq"};